<template>
  <div>
    <span class="mensagem">{{ msgSemRegistros }}</span>
    <BButton
      v-if="rotaTelaCadastro"
      class="alerta-registros-botao"
      @click.prevent="abrirTelaCadastro">
      +
    </BButton>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue/es/components'

export default {
  name: 'ErroConexao',
  props: {
    msgSemRegistros: {
      type: String,
      default: '',
      required: true,
    },
    rotaTelaCadastro: {
      type: String,
      default: '',
    },
  },
  components: {
    BButton,
  },
  methods: {
    abrirTelaCadastro() {
      this.$router.push({ name: this.rotaTelaCadastro })
    },
  },
}

</script>

<style lang="scss" scoped>

.mensagem {
  font-size: 0.9rem;
  color: white;
}

.alerta-registros-botao {
  border: none;
  background-color: #fff;
  border: 1px solid #ced4da;
  color: black;
  border-radius: 0.25rem;
}

</style>
